import { render, staticRenderFns } from "./JgpTree.vue?vue&type=template&id=095793fa&"
import script from "./JgpTree.vue?vue&type=script&lang=js&"
export * from "./JgpTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports